<template>
    <tr class="row-details">
        <td colspan="6">
            <table class="table table-inline table-details">
                <tbody>
                    <tr>
                        <td>
                            <ul>
                                <li>
                                    <h4>Adresse :</h4>
                                </li>
                                <template v-if="showMainAddress">
                                    <li>{{mainAddress.street_line1}}</li>
                                    <li v-if="mainAddress.street_line2">{{mainAddress.street_line2}}</li>
                                    <li>{{mainAddress.zipcode}} {{mainAddress.city}} - {{mainAddress.decoded_country}}</li>
                                </template>
                            </ul>
                        </td>
                        <td>
                            <ul>
                                <li>
                                    <h4>Représentants légaux :</h4>
                                </li>
                                <ul v-for="repr in decodedRepresentatives" :key="'customer-details-representative-'+repr.id">
                                    <li> > {{repr.title}}</li>
                                    <li>{{repr.quality}}</li>
                                    <li v-if="repr.mobile_phone" class="semi-bold">Mobile: {{repr.mobile_phone}}</li>
                                    <li v-if="repr.phone" class="semi-bold">Repré.: {{repr.phone}}</li>
                                    <li>
                                        <a class="semi-bold direct_link" style="color:#666;" :href="`mailto:${repr.email}`">{{repr.email}}</a>
                                    </li>
                                </ul>
                            </ul>
                        </td>
                        <td>
                            <h4>Contrats en cours :</h4>
                            <template v-for="contract in decodedContracts">
                                <ul :key="'customer-details-contract-'+contract.id"
                                    class="fixed_size"
                                    v-if="!contract.order.cancelled">
                                    <li class="direct_link" @click="redirectToContractDetails(contract)" title="Lien direct vers les contrats.">{{contract.decoded_type}}
                                        {{contract.organization_display_name}}</li>
                                    <li>{{contract.agency.street_line1}}</li>
                                    <li v-if="contract.agency.street_line2">{{contract.agency.street_line2}}</li>
                                    <li>{{contract.agency.zipcode}} {{contract.agency.city}}</li>
                                    <li v-if="contract.end_date">
                                        <span class="label label-danger">sortie le {{contract.end_date | moment-date}}</span>
                                    </li>
                                </ul>
                            </template>
                        </td>
                        <td>
                            <h4>Adresse de réexpedition actuelle :</h4>
                            <template v-for="(contract, idx) in decodedContracts">
                                <ul :key="'customer-details-forward-address-contract-'+contract.id"
                                    class="fixed_size"
                                    v-if="!contract.order.cancelled">
                                    <template v-if="contract.isMailForwarded">
                                        <template v-if="showForwardingAddress(idx)">
                                            <li>{{forwardingAddresses[idx].street_line1}}</li>
                                            <li v-if="forwardingAddresses[idx].street_line2">{{forwardingAddresses[idx].street_line2}}</li>
                                            <li>{{forwardingAddresses[idx].zipcode}} {{forwardingAddresses[idx].city}} - {{forwardingAddresses[idx].decoded_country}}</li>
                                        </template>
                                    </template>
                                    <li v-else>Pas d'adresse de réexpedition</li>
                                </ul>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script type="text/babel">
    import { mapMutations, mapState, mapActions } from 'vuex'
    import representativesMixin from 'mixins/representatives'
    import routeWatcher from 'mixins/routeWatcher'
    import contractsMixin from 'mixins/contracts'

    export default {
        props: ['customer'],

        mixins: [
            representativesMixin,
            contractsMixin
        ],

        data() {
            return {
                forwardingAddresses: [],
                mainAddress: null,
                representatives: null
            }
        },

        created() {
            this.fetchCustomerData()
        },

        mounted() {
            const unwatchForwardingAddresses = this.$watch(
                'someForwardingAddress',
                function (cond) {
                    if (!cond)
                        return;

                    Promise.all(_.map(
                            this.decodedContracts,
                            (contract) => contract.isMailForwarded && this.getActiveMailForwardingAddress(contract.id, contract.mailForwardOption.id)
                        )).then(data => this.forwardingAddresses = _.map(data, 'data.address'))
                        .then(() => unwatchForwardingAddresses())
                }, {
                    immediate: true
                }
            )
        },

        computed: {

            someForwardingAddress() {
                return this.decodedContracts &&
                    this.decodedContracts.length && _.some(this.decodedContracts, 'isMailForwarded')
            },

            showMainAddress() {
                return !_.isEmpty(this.mainAddress)
            },

            decodedRepresentatives() {
                return this.decodeRepresentativesForSearch(this.representatives)
            },

            decodedContracts() {
                const contracts = this.extractAgenciesFromOffer(this.customer.contracts)

                const mappedContracts = _.map(contracts, contract => {
                    const mailForwardOption = this.findMailOption(contract.contract_options, true),
                        isMailForwarded = (mailForwardOption) ? this.isMailForwarded(mailForwardOption, true) : false
                    let decodedContract = {
                        isMailForwarded,
                        ...contract,
                    }

                    if (isMailForwarded)
                        decodedContract = {
                            mailForwardOption,
                            ...decodedContract,
                        }

                    return decodedContract
                })

                return this.getFilteredContractsList(mappedContracts)
            }
        },

        methods: {

            showForwardingAddress(idx) {
                return this.forwardingAddresses.length &&
                    this.forwardingAddresses[idx] && !_.isEmpty(this.forwardingAddresses[idx])
            },

            fetchCustomerData() {
                this.getMainAddress(this.customer.id).then( (response) => this.mainAddress = response.data.address)
                this.getRepresentatives(this.customer.id).then( (response) => this.representatives = response.data.representatives)
            },

            getMainAddress(customerId) {
                return this.axios.get(`customers/${customerId}/addresses/main`)
            },

            getActiveMailForwardingAddress(contractId, contractOptionId) {
                return this.axios.get(`contracts/${contractId}/options/${contractOptionId}/addresses/active`)
            },

            getRepresentatives(customerId) {
                return this.axios.get(`customers/${customerId}/representatives`)
            }
        }
    }

</script>

<style lang="scss" scoped>
    .table-details {
        tbody {
            tr {
                td {
                    padding: 0;
                    vertical-align: top;
                    width: auto;

                    ul {
                        padding: 0;

                        li {
                            list-style-type: none;
                            font-size: 0.8rem;
                            line-height: 20px;

                            &:first-child {
                                // font-weight: bold;
                            }
                        }
                    }
                }
            }
        }
    }

    .direct_link {
        text-decoration: none;
    }

    .direct_link:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .fixed_size {
        height: 60px;
    }

</style>



// WEBPACK FOOTER //
// client/components/SearchOverlay/ItemDetails.vue